<template>
	<div></div>
</template>
<script>
export default {
	data() {
		return {};
	},
	created() {
		let _url = this.$route.query;
		let _str = '';
		for (let i in _url) {
			_str += _url[i];
		}
		const _path = this.$route.query;
		this.$router.push({
			path: _str
		});
	}
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/Redirect/index.vue